import React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
} from "@mui/material";
import { KeyboardArrowDownRounded } from "@mui/icons-material";

export default function Select(props) {
  const {
    name,
    label,
    value,
    variant,
    onChange,
    options,
    required,
    fullWidth = true,
    error = null,
    showNA = false,
    ...other
  } = props;

  return (
    <FormControl
      variant={variant || "filled"}
      fullWidth={fullWidth}
      required={required}
      sx={{
        "& .MuiFilledInput-root::before": {
          borderBottom: `1px solid var(--${
            required ? "error" : "primary"
          }-color)`,
        },
      }}
      {...other}
    >
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        label={label}
        name={name}
        value={options.some((j) => j.id === value) ? value : ""}
        onChange={onChange}
        MenuProps={{
          PaperProps: {
            className: "bg-white",
            sx: { borderRadius: "0px 0px 10px 10px" },
          },
        }}
        IconComponent={(e) => <KeyboardArrowDownRounded {...e} />}
        {...(error && { error: true })}
      >
        {showNA && (
          <MenuItem value="">
            <em>N/A</em>
          </MenuItem>
        )}
        {options.map((item, index) => (
          <MenuItem key={index} value={item.id}>
            {item.label}
          </MenuItem>
        ))}
      </MuiSelect>
      {error && (
        <FormHelperText className="error-color">{error}</FormHelperText>
      )}
    </FormControl>
  );
}
